<template>
  <div :class="paragraphClassList">
    <Container>
      <BlokkliField :list="header" name="field_header" />
      <iframe
        id="jobboard"
        ref="jobboardIframe"
        src="https://live.solique.ch/aoz/"
        width="100%"
        scrolling="no"
        style="border: 0"
      />
    </Container>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphIframeJobsFragment } from '#graphql-operations'
import { onMounted, onUnmounted, ref } from 'vue'

const { options } = defineBlokkli({
  bundle: 'iframe_jobs',
  globalOptions: ['spacing'],
})

defineProps<{
  header?: ParagraphIframeJobsFragment['header']
}>()

const jobboardIframe = ref<HTMLIFrameElement | null>(null)

// Function to handle message events from the iframe
const handleJobboardMessage = (event: Event) => {
  if (!jobboardIframe.value) return
  const messageEvent = event as MessageEvent
  const height = messageEvent.data || 600
  jobboardIframe.value.style.height = height + 'px'
}

// Set up event listeners when the component is mounted
onMounted(() => {
  if (window.addEventListener) {
    window.addEventListener('message', handleJobboardMessage, false)
  } else if ('attachEvent' in window) {
    ;(
      window as unknown as {
        attachEvent: (type: string, listener: EventListener) => void
      }
    ).attachEvent('onmessage', handleJobboardMessage)
  }
})

// Clean up event listeners when the component is unmounted
onUnmounted(() => {
  if (window.removeEventListener) {
    window.removeEventListener('message', handleJobboardMessage)
  } else if ('detachEvent' in window) {
    ;(
      window as unknown as {
        detachEvent: (type: string, listener: EventListener) => void
      }
    ).detachEvent('onmessage', handleJobboardMessage)
  }
})

const paragraphClassList = computed(() => {
  const classList = []

  if (options.value.spacing === 'small') {
    classList.push('py-6', 'lg:py-10')
  } else if (options.value.spacing === 'large') {
    classList.push('py-12', 'lg:py-20')
  }

  return classList
})
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100vh;
}

#jobboard {
  iframe html {
    height: 100%;
    overflow-y: hidden;
  }
  #header-section {
    display: none;
  }
}
</style>
